<!-- Content Header (Page header) -->
<section class="content-header">
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-sm-6">
                <h1>Productos Delivery</h1>
            </div>
            <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                    <li class="breadcrumb-item"><a [routerLink]="['/']">Dashboard</a></li>
                    <li class="breadcrumb-item active">Productos Delivery</li>
                </ol>
            </div>
        </div>
    </div><!-- /.container-fluid -->
</section>

<!-- Main content -->
<section class="content">
    <div class="container-fluid">
        <div class="row  justify-content-center">
            <div class="col-md-8">
                <app-lista-productos (updateData)="getData()" [rows]="rows" [tempRows]="tempRows" [showFilter]="false" [showDelete]="false"></app-lista-productos>
            </div>
        </div>
    </div>
</section>
<!-- /.content -->